var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.label}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"https://jsonplaceholder.typicode.com/posts/","auto-upload":false,"disabled":_vm.preview}},[_c('el-button',{attrs:{"slot":"trigger","size":"small","plain":""},slot:"trigger"},[_vm._v("Select file")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }